import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "src/components/ui/button";

export default function ConfirmPW() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-7">
          <div className="flex items-center justify-center mb-4">
            <a href="http://www.samsungshi.com/kor/default.aspx">
              <img alt="Logo" src="/images/g1313.png" className="h-8 w-auto" />
            </a>
          </div>
          <h1 className="text-foreground font-extrabold text-[19px] tracking-tight mb-2">
            삼성중공업 현장공무 LOA 결재 시스템
          </h1>
        </div>

        <div className="rounded-lg border bg-card p-6 text-center">
          <h2 className="text-foreground font-bold text-base mb-6">
            비밀번호가 변경되었습니다.
          </h2>
          <img
            src="/images/ok.png"
            className="max-w-full max-h-[220px] mx-auto mb-6"
            alt=""
          />
          <Button asChild className="w-full">
            <RouterLink to={{ pathname: "/login" }}>로그인</RouterLink>
          </Button>
        </div>
      </div>
    </div>
  );
}
